// src/pages/QuizPage/components/SignsView.tsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { signsAPI } from "../../../api";
import { mapLang, UiLang } from "../../../utils/langMap";

const IMG_BASE = process.env.REACT_APP_BASE_URL_IMAGE;
// REACT_APP_BASE_URL_IMAGE allaqachon ".../storage" bilan tugaydi,
// lekin backend image_url o'zi "storage/..." bilan boshlanadi — shu sabab domen ildizi kerak.
const ROOT_BASE = IMG_BASE?.replace(/\/storage\/?$/, "") ?? "";
const DEFAULT_IMG = "https://avtomind.uz/storage/photos/default.webp";

type SignItem = {
  image: string;
  image_url?: string;
  title: string;
  sign: string;
  description: string;
};

interface SignsViewProps {
  categoryId?: string;
  lang: UiLang;
  setLang: (lang: UiLang) => void;
}

export default function SignsView({
  categoryId,
  lang,
  setLang,
}: SignsViewProps) {
  const navigate = useNavigate();
  const [items, setItems] = useState<SignItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!categoryId) {
      setItems([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    signsAPI
      .getByCategory(categoryId, mapLang(lang))
      .then((res) => setItems(res.data?.items ?? []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [categoryId, lang]);

  return (
    <div className="min-h-screen bg-[#0A0E1A] text-white p-4">
      <div className="max-w-3xl mx-auto flex items-center justify-between mb-6">
        <button
          onClick={() => navigate(-1)}
          className="px-4 py-2 bg-white/5 border border-white/10 rounded-xl font-bold">
          ← Orqaga
        </button>
        <select
          value={lang}
          onChange={(e) => setLang(e.target.value as UiLang)}
          className="bg-white/5 border border-white/10 rounded-xl px-4 py-2 outline-none text-sm font-bold">
          <option value="oz">O'zbekcha</option>
          <option value="uz">Ўзбекча</option>
          <option value="ru">Русский</option>
        </select>
      </div>
      {loading ?
        <div className="flex justify-center py-20">
          <Loader2 className="animate-spin text-blue-500" size={24} />
        </div>
      : <div className="max-w-3xl mx-auto grid gap-4">
          {items.length === 0 ?
            <div className="text-gray-400 text-center py-20">
              Ma'lumot topilmadi
            </div>
          : items.map((item, i) => {
              const imgSrc =
                item.image_url ? `${ROOT_BASE}/${item.image_url}`
                : item.image ? `${IMG_BASE}/signs/${item.image}`
                : DEFAULT_IMG;
              return (
                <div
                  key={i}
                  className="bg-white/5 border border-white/10 p-4 rounded-2xl">
                  <div className="flex gap-4 items-start">
                    <img
                      src={imgSrc}
                      alt={item.title}
                      className="w-24 h-24 object-contain bg-black/30 rounded-xl shrink-0"
                    />
                    <div>
                      <div className="text-base font-bold text-white">
                        {item.title}
                      </div>
                      <div className="text-blue-300 font-semibold text-sm mt-1">
                        {item.sign}
                      </div>
                      {item.description && (
                        <div className="text-gray-400 text-sm mt-2 leading-relaxed">
                          {item.description}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
      }
    </div>
  );
}
